// extracted by mini-css-extract-plugin
export default {"btn":"CtaButton_btn__M7fg3","btn__variant":"CtaButton_btn__variant__+oyCx"};